export type IDoctor = {
  id: IDoctorId;
  title: string;
  name: string;
  gender?: Gender
}

export enum Gender {
  male = 1,
  female = 2
}

export type IDoctorId = {
  value: string
} 